import type { FaireProductEntity } from "../../entity_types/product";

export const p_u2nue4qfqt: FaireProductEntity = {
  token: "p_u2nue4qfqt",
  type: "product",
  name: "My Beautiful Mother Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/2e07a7eed44e2923233efd6756f884657a338019ea9ac00229f5659d7f68794e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/390c459c008ed3b131f2d19be16906e4378ce15e3b45ad765db47dc418e76c5a.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:52.992Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
